import { render, staticRenderFns } from "./BaseResendOrderDetails.vue?vue&type=template&id=27824969&scoped=true"
import script from "./BaseResendOrderDetails.vue?vue&type=script&lang=js"
export * from "./BaseResendOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./BaseResendOrderDetails.vue?vue&type=style&index=0&id=27824969&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27824969",
  null
  
)

export default component.exports